import {XHRBackend, Http, RequestOptions} from "@angular/http";
import {InterceptedHttp} from "./http.interceptor";


export function httpFactory(xhrBackend: XHRBackend, requestOptions: RequestOptions): Http {

    return new InterceptedHttp(xhrBackend, requestOptions);
}



// WEBPACK FOOTER //
// ./src/app/shared/http_intercept/http.factory.ts